'use client';

import { authStore } from '@wwe-portal/web/providers/stores/auth-store';
import { sendCommonTitanEvent } from './common';
import { sendGTMEvent } from './gtm-helper';

export const sendUserConnectEvent = ({
  scopelyId,
  userId,
}: {
  scopelyId?: string;
  userId?: string;
}) => {
  const connection = authStore.getState().loginMethod;
  sendCommonTitanEvent('sys.connect', {
    scopelyId,
    userId,
    connection,
    eventSource: 'web_portal',
    platform: 'web',
  });
};

export const sendScopelyIdAuthEvent = (
  userId: string,
  isPortalRegister?: boolean
) => {
  sendGTMEvent({
    category: 'Scopely Authentication',
    event: isPortalRegister ? 'scopelyId_register' : 'scopelyId_loggedin',
    action: isPortalRegister
      ? `scopelyId-register/${userId}`
      : `scopelyId-loggedin/${userId}`,
  });
};

export const sendFacebookAuthEvent = (
  userId: string,
  isPortalRegister?: boolean
) => {
  sendGTMEvent({
    category: 'Facebook Authentication',
    event: isPortalRegister ? 'fb_register' : 'fb_loggedin',
    action: isPortalRegister
      ? `fb-register/${userId}`
      : `fb-loggedin/${userId}`,
  });
};
